import { useState } from 'react';
import { createContainer } from 'unstated-next';

export interface Instructions {
  resortInstructions?: string;
  disneyInstructions?: string;
}

export interface RestrictionStatus {
  isPending: boolean;
  isBlocked: boolean;
}

const emptyRestriction: RestrictionStatus = {
  isPending: false,
  isBlocked: false,
};

const useAccessoriesScreenState = () => {
  const [deliveryInstructions, setDeliveryInstructions] =
    useState<Instructions>({});
  const [returnInstructions, setReturnInstructions] = useState<Instructions>(
    {},
  );
  const [strollerIsAvailable, setStrollerIsAvailable] = useState<boolean>();
  const [deliveryRestriction, setDeliveryRestriction] =
    useState<RestrictionStatus>(emptyRestriction);
  const [returnRestriction, setReturnRestriction] =
    useState<RestrictionStatus>(emptyRestriction);

  return {
    deliveryInstructions,
    setDeliveryInstructions,
    returnInstructions,
    setReturnInstructions,
    strollerIsAvailable,
    setStrollerIsAvailable,
    deliveryRestriction,
    setDeliveryRestriction,
    returnRestriction,
    setReturnRestriction,
  };
};

export const AccessoriesScreenContainer = createContainer(
  useAccessoriesScreenState,
);
